export const APPROVAL_SECTION_KEY = 'APPROVAL';